import { render, staticRenderFns } from "./AllCopyrightAssignmentTransferSubmissions.vue?vue&type=template&id=01252415&scoped=true&"
import script from "./AllCopyrightAssignmentTransferSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllCopyrightAssignmentTransferSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllCopyrightAssignmentTransferSubmissions.vue?vue&type=style&index=0&id=01252415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01252415",
  null
  
)

export default component.exports